import { createFileRoute } from "@tanstack/react-router";
import { SplitTestsTab } from "@/components/admin/SplitTestsTab";

export const Route = createFileRoute("/admin/split-tests")({
  head: () => ({ meta: [{ title: "Split Tests · Admin · INFLOW Marketing" }, { name: "description", content: "A/B/C-test landing page variants." }, { name: "robots", content: "noindex,nofollow" }] }),
  component: () => (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-3xl tracking-tight">Split tests</h1>
        <p className="text-sm text-muted-foreground mt-1">
          A/B/C-test landing page variants. The survey, conditional logic, and GHL integration are shared across all variants.
        </p>
      </div>
      <SplitTestsTab />
    </div>
  ),
});
